<template>
  <loading v-model:active="isLoading" :can-cancel="false" :is-full-page="true" />

  <h3>Cadastrar Lista Newsletter</h3>

  <div class="row">
    <div class="col-md-12">
      <div class="row">
        <!-- NOME -->
        <div class="col-sm-12">
          <div class="form-group">
            <label for="exampleInputEmail1">Nome</label>
            <input @keyup="formatar" class="form-control" id="nome" v-model="formData.name" />

            <span style="color: red" v-for="error in v$.name.$errors" :key="error.$uid">
              {{ error.$message }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="card-footer" style="width: 100%">
      <button type="submit" class="btn btn-primary" @click="store()">Salvar</button>
      <a id="close_cadastrar" data-dismiss="modal" @click="close" class="btn btn-danger" style="margin-left: 15px">Fechar</a>
    </div>
  </div>
</template>

<script>
import sweetAlert from "../../controller/sweetAlert";
import Swal from "sweetalert2/dist/sweetalert2.js";
import "vue-loading-overlay/dist/vue-loading.css";
import Loading from "vue-loading-overlay";

import useVueLidate from "@vuelidate/core";
import { required } from "../../locales/i18n.js";
import { computed, reactive } from "vue";

export default {
  mixins: [sweetAlert, Swal],

  props: ["closeModal", "acaoRealizada"],

  components: { Loading },

  data() {
    return {
      isLoading: false,
    };
  },

  setup() {
    const formData = reactive({
      name: "",
    });

    const rules = computed(() => {
      return {
        name: { required },
      };
    });

    const v$ = useVueLidate(rules, formData);

    return { formData, v$ };
  },

  mounted() {},

  methods: {
    formatar() {
      this.formData.name = this.formData.name.toUpperCase();
    },

    close() {
      let btn = document.getElementById("close_cadastrar");
      btn.click();

      this.closeModal();
    },

    async store() {
      const result = await this.v$.$validate();

      if (result) {
        this.isLoading = true;

        let data = {
          nome: this.formData.name,
        };

        console.log("Cadastrar");
        console.log(data);

        axios
          .post(`/admin/newsletter_listas/store`, data)
          .then((response) => {
            this.isLoading = false;

            if (response.data.success) {
              let btn = document.getElementById("close_cadastrar");
              btn.click();

              this.showSuccessMessageWithButton("Sucesso", "Lista cadastrada!");
              this.acaoRealizada("cadastrar");
            } else {
              this.showErrorMessageWithButton("Ops...", response.data.msg);
            }
          })
          .catch((error) => {
            this.isLoading = false;
            this.showErrorMessageWithButton("Ops..", error);
            console.log(error);
          });
      }
    },
  },
};
</script>
